import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BasicLayoutComponent } from 'src/app/common/layouts/basicLayout.component';
import { AuthGuard, PrepareGuard } from 'src/app/core/core.module';
import { InvoiceCreateComponent } from './invoice-create/invoice-create.component';
import { InvoiceSearchComponent } from './invoice-search/invoice-search.component';
import { InvoiceDetailComponent } from './invoice-detail/invoice-detail.component';
import { EmailDialogComponent } from './email-dialog/email-dialog.component';
import { PurchaseOrderLinesSearchComponent } from './purchase-order-lines-search/purchase-order-lines-search.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'invoices',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'search', pathMatch: 'full' },
                    { path: 'create', component: InvoiceCreateComponent, data: { title: 'Create Invoice' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'search', component: InvoiceSearchComponent, data: { title: 'Invoices' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'purchase-order', component: PurchaseOrderLinesSearchComponent, data: { title: 'Purchase Orders' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: ':id', component: InvoiceDetailComponent, data: { title: 'Detail' }, canActivate: [AuthGuard, PrepareGuard] },
                    // { path: ':id', component: JobDetailComponent, data: { title: 'Detail' }, canActivate: [AuthGuard, PrepareGuard], canDeactivate: [PendingChangesGuard] },
                ],
            },
        ]),
    ],
    declarations: [InvoiceCreateComponent, InvoiceSearchComponent, InvoiceDetailComponent, EmailDialogComponent, PurchaseOrderLinesSearchComponent]
})
export class InvoicesModule {}
